import { useState, useEffect } from 'react';

const LG_BREAKPOINT = 1024;
const MOBILE_QUERY = `(max-width: ${LG_BREAKPOINT - 1}px)`;

export function useMediaQuery(query: string): boolean {
  // Ленивая инициализация, а не false: иначе первый кадр на телефоне всегда
  // десктопный и экран пересобирается сразу после монтирования.
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const media = window.matchMedia(query);

    const updateMatches = () => setMatches(media.matches);
    updateMatches();

    // Современный подход с addEventListener
    media.addEventListener('change', updateMatches);
    return () => media.removeEventListener('change', updateMatches);
  }, [query]);

  return matches;
}

export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}
